import Accounts from './Accounts.json';
import BankId from './BankId.json';
import BankSwap from './BankSwap.json';
import BecomeCustomer from './BecomeCustomer.json';
import Cards from './Cards.json';
import Components from './Components.json';
import EpkFlex from './EpkFlex.json';
import Figma from './Figma.json';
import FormValidation from './FormValidation.json';
import Forms from './Forms.json';
import Funds from './Funds.json';
import Hunting from './Hunting.json';
import Insurance from './Insurance.json';
import Loans from './Loans.json';
import Overview from './Overview.json';
import PaymentAgreements from './PaymentAgreements.json';
import Payments from './Payments.json';
import PendingPayments from './PendingPayments.json';
import Pension from './Pension.json';
import Property from './Property.json';
import Savings from './Savings.json';
import Spendings from './Spendings.json';
import Transfers from './Transfers.json';

export default {
  ...Accounts,
  ...BankId,
  ...BankSwap,
  ...BecomeCustomer,
  ...Cards,
  ...Components,
  ...EpkFlex,
  ...Figma,
  ...FormValidation,
  ...Forms,
  ...Funds,
  ...Hunting,
  ...Insurance,
  ...Loans,
  ...Overview,
  ...PaymentAgreements,
  ...Payments,
  ...PendingPayments,
  ...Pension,
  ...Property,
  ...Savings,
  ...Spendings,
  ...Transfers,
};
